<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <UserManagement />
    </div>
  </div>
</template>

<script>
import UserManagement from '../components/UserManagement.vue'

export default {
  name: 'UserManagementView',
  components: {
    UserManagement
  }
}
</script>
